import React, { useEffect, useState } from "react";
import { FiDownload, FiXCircle } from "react-icons/fi";
import Modal from "../../../../components/Modal";
import { NoRecordsFoundMessage, PleaseWaitMessage } from "../../../../../_layout/_helpers";
import BootstrapTable from "react-bootstrap-table-next";
import { Pagination } from "react-bootstrap";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as uiHelpers from "../DashboardConsorcioUIHelpers";
import * as actions from "../../../../_redux/dashboardConsorcio/dashboardConsorcioActions";
import * as columnFormatters from "./column-formatters";
import moment from "moment";
import NumberFormat from "react-number-format";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';


function moneyMask(value) {
  return (
    <NumberFormat
      decimalSeparator=","
      thousandSeparator="."
      decimalScale={2}
      prefix="R$ "
      displayType={'text'}
      value={value !== undefined && value}
    />
  )
}

export default function DashboardConsorcioTable() {
  const {
    dashboardConsorcioFiltro,
  } = useSelector(
    state => ({
      dashboardConsorcioFiltro: state.dashboardConsorcio.dashboardConsorcioFiltro,
    }),
    shallowEqual
  );

  const [modalAbertaDetalhe, setModalAbertaDetalhe] = useState(false);
  const [modalDados, setModalDados] = useState({});


  const [modalAbertaDetalheDownload, setModalAbertaDetalheDownload] = useState(false);
  const [modalDadosDownload, setModalDadosDownload] = useState(null);

  useEffect(() => {
    if (modalAbertaDetalheDownload) {
      console.log(modalDadosDownload.id, "modalDadosDownload")
      dispatch(actions.fetchFaturasDownload(modalDadosDownload.id)).then(() => {
        MySwal.fire({
          icon: 'success',
          title: (
            <div>
              <p>O download será realizado em instantes, por favor não atualizar a tela.</p>
              <br />
              <p>Caso demore mais de 5 minutos para o download ser realizado, entre em contato com o suporte.</p>
              <br />
            </div>
          ),
          width: 700,
          allowOutsideClick: false,
          confirmButtonText: 'Fechar',
        }).then((result) => {
          if (result.isConfirmed) {
            setModalAbertaDetalheDownload(false);
          }
        });
      })
    }
  }, [modalAbertaDetalheDownload]);

  function abrirModalDetalhe(data) {
    setModalAbertaDetalhe(true);
    setModalDados(data);
  };

  function fecharModalDetalhe() {
    setModalAbertaDetalhe(false);
  };

  function abrirModalDownloadDetalhe(data) {
    setModalAbertaDetalheDownload(true);
    setModalDadosDownload(data);
  };

  function fecharModalDownloadDetalhe() {
    setModalAbertaDetalheDownload(false);
  };

  const MySwal = withReactContent(Swal)


  const dispatch = useDispatch();

  function handlerTableChange() {
    return (type, { page, sizePerPage, sortField, sortOrder, data }) => {
      dispatch(actions.setPaginationDashboardConsorcio({ page, sizePerPage, sortField, sortOrder }));
    };
  };

  const { currentState } = useSelector(
    state => ({ currentState: state.dashboardConsorcio }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const columns = [
    {
      dataField: "fatura",
      text: "Pagamento",
      sort: true,
      classes: "p-2 border-b w-fit",
      headerClasses: "p-2 w-fit"
    },
    {
      dataField: "mesReferencia",
      text: "Mês Referência",
      sort: true,
      classes: "p-2 border-b w-fit text-center",
      headerClasses: "p-2 w-fit text-center",
      formatter: cell => moment(cell).format("MMM/YYYY"),
    },
    {
      dataField: "dataVencimento",
      text: "Vencimento",
      sort: true,
      classes: "p-2 border-b w-fit text-center",
      headerClasses: "p-2 w-fit text-center",
      formatter: cell => moment(cell).format("DD/MM/YYYY"),
    },
    {
      dataField: "valor",
      text: "Valor",
      sort: true,
      classes: "p-2 border-b w-fit text-center",
      headerClasses: "p-2 w-fit text-center",
      formatter: cell => (
        <NumberFormat
          decimalSeparator=","
          thousandSeparator="."
          decimalScale={2}
          prefix="R$ "
          displayType={'text'}
          value={cell}
        />
      ),
    },
    {
      dataField: "statusPagamento",
      text: "Status de Pagamento",
      sort: true,
      classes: "p-2 border-b w-fit text-center",
      headerClasses: "p-2 w-fit text-center",
      formatter: cell => columnFormatters.StatusFormatter(cell),
    },
    {
      dataField: "action",
      text: "Ações",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        abrirModalDetalhe,
        abrirModalDownloadDetalhe
      },
      classes: "w-fit p-2 border-b whitespace-nowrap",
      headerClasses: "p-2 w-fit whitespace-nowrap text-center"
    }
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: dashboardConsorcioFiltro.pageSize,
    page: dashboardConsorcioFiltro.pageNumber
  };



  return (
    <>
      <div className="flex flex-col gap-3 bg-white h-full rounded-lg drop-shadow py-5 px-8">
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({ paginationProps, paginationTableProps }) => {
            return (
              <Pagination
                isLoading={listLoading}
                paginationProps={paginationProps}
              >
                <div className="flex justify-between mb-4">
                  <div>
                    <h2 className="text-3xl font-bold text-gray-600">
                      Histórico de faturas
                    </h2>
                    <p className="text-base text-normal text-gray-500 mt-1">
                      Total de <strong>{totalCount ? totalCount : 0}</strong> fatura(s) retornada(s)
                    </p>
                  </div>
                </div>
                <div className="overflow-x-auto ">
                  <BootstrapTable
                    classes="min-w-full"
                    bodyClasses="px-6 text-sm bg-white border-b text-left text-gray-600"
                    headerClasses="px-6 py-3 text-left text-xs text-gray-500 uppercase bg-gray-50"
                    bootstrap4
                    bordered={false}
                    remote
                    keyField="id"
                    data={entities === null || entities === undefined ? [] : entities}
                    columns={columns}
                    noDataIndication={
                      <>
                        <div className="flex flex-col lg:flex-row justify-start lg:justify-center items-center py-4 space-x-5">
                          <div>
                            <p className="text-gray-600 font-normal text-base">
                              Não foi encontrado nenhuma Fatura
                            </p>
                          </div>
                        </div>
                      </>
                    }
                    defaultSorted={uiHelpers.defaultSorted}
                    onTableChange={() => handlerTableChange()}
                    {...paginationTableProps}
                  >
                    <PleaseWaitMessage entities={entities} />
                    <NoRecordsFoundMessage entities={entities} />
                  </BootstrapTable>
                </div>
              </Pagination>
            );
          }}
        </PaginationProvider>
      </div>
      <Modal isOpen={modalAbertaDetalhe} onClose={fecharModalDetalhe}>
        <div className="py-4 px-8 bg-[#3f3f46]">
          <div className="flex items-center justify-between">
            <h2 className="text-3xl font-bold text-white">Consórcio</h2>
            <button onClick={fecharModalDetalhe}>
              <FiXCircle size={28} className="text-white hover:opacity-70" />
            </button>
          </div>
          <div className="flex justify-between items-end w-full mt-4">
            <div className="flex flex-col gap-2">
              <div className="flex flex-col gap-0.5">
                <h3 className="text-white font-bold">Número da Fatura:</h3>
                <span className=" text-gray-100 font-normal">{modalDados.numFatura ? modalDados.numFatura : "-"}</span>
              </div>
              <div className="flex flex-col gap-0.5">
                <h3 className="text-white font-bold">Data:</h3>
                <span className="text-gray-100 font-normal">
                  {moment(modalDados.mesReferencia).format("MMMM/YYYY")}
                </span>
              </div>
            </div>
            {modalDados.situacao === "A" ? (
              <button
                type="button"
                className="px-14 py-2 bg-white rounded-md text-gray-600 font-medium"
                disabled
              >
                Pago
              </button>
            ) : (
              <button
                type="button"
                onClick={() => window.open(modalDados.pathCloudBoletoRecibo, "_blank")}
                className="px-14 py-2 bg-mainBlue rounded-md text-white font-medium hover:bg-blue-700"
              >
                Pagar
              </button>
            )}
          </div>
        </div>
        <div className="py-4 px-8 bg-white">
          {modalDados && (
            <div className="flex justify-between items-end w-full my-2">
              <div className="flex flex-col gap-5">
                <div className="flex flex-col gap-0.5">
                  <h3 className="text-gray-600 font-bold ">Valor</h3>
                  <span className="text-gray-600 font-normal">{moneyMask(modalDados.valor)}</span>
                </div>
                <div className="flex flex-col gap-0.5">
                  <h3 className="text-gray-600 font-bold">Data de Pagamento</h3>
                  <span className=" text-gray-600 font-normal">{modalDados.dataPagamento !== null ? moment(modalDados.dataPagamento).format("DD/MM/YYYY") : "-"}</span>
                </div>
                {modalDados.uc !== null && (
                  <div className="flex flex-col gap-0.5">
                    <h3 className="text-gray-600 font-bold">Unidade consumidora</h3>
                    <span className=" text-gray-600 font-normal">
                      {modalDados.uc}<br />
                      {modalDados.logradouro}, {modalDados.numero}, {modalDados.bairro} <br />
                      {modalDados.cidade} - {modalDados.uf} <br />
                      {modalDados.cep}
                    </span>
                  </div>
                )}
                <div className="flex flex-col gap-0.5">
                  <h3 className="text-gray-600 font-bold">Observação</h3>
                  <span className=" text-gray-600 font-normal">
                    {modalDados.observacao}
                  </span>
                </div>
              </div>
              <button onClick={fecharModalDetalhe}>
                <FiDownload
                  size={24}
                  className="text-gray-500 hover:opacity-70"
                />
              </button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
